<template>
    <v-list-item @click="emitClick()" :class="item.Active == 1 ? '' : 'deactivated'">
        <v-list-item-icon class="my-auto mr-4">
            <avatar :color="isMe ? 'red' : getUserTypeColor(item.UserTypeId)" :fullname="item.Name" small="true">
            </avatar>
        </v-list-item-icon>
        <v-list-item-content>
            <v-list-item-title>
                {{ item.Name }} {{ isMe ? $t("servicesystem.common_objects.user.is_you_indicator") : '' }}
            </v-list-item-title>
            <v-list-item-subtitle>
                {{ item.EmailAdress }}
            </v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-content v-if="!isPhoneBool" style="max-width: 150px;">
            <UserTypeTextTemplate :id="item.UserTypeId" />
        </v-list-item-content>

        <v-list-item-action v-if="!isPhoneBool" class="ma-0 d-flex flex-row align-center justify-start"
            style="width: 230px;">
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-icon v-text="item.IsTechnician ? 'mdi-calendar-account' : 'mdi-calendar-remove-outline'"
                        :color="item.IsTechnician ? '' : 'disabled'" class="mx-1" v-bind="attrs" v-on="on">
                    </v-icon>
                </template>
                <span>{{ item.IsTechnician ? $t("servicesystem.common_objects.user.is_bookable") :
                    $t("servicesystem.common_objects.user.is_not_bookable") }}</span>
            </v-tooltip>
            <PartnerCompanyListItem v-if="item.PartnerCompanyId" :item="item.PartnerCompany" class="pl-1"
                @click="openPartnerCompany(item.PartnerCompanyId)">
            </PartnerCompanyListItem>
        </v-list-item-action>

        <v-list-item-action class="ma-0">
            <v-row no-gutters align="center">
                <v-switch :input-value="item.Active" :loading="item.loading == 'Active'" :readonly="!!item.loading"
                    @click.stop="toggleUserActive()" dense class="mt-0 px-3 pt-1" hide-details>
                </v-switch>
                <!-- 
                <ActionMenu v-if="true" :actionList="actionlist" :parentcontext="thiscontext">
                </ActionMenu>
                -->
            </v-row>
        </v-list-item-action>
    </v-list-item>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import UserTypeMixin from "@/helpers/Mixins/UserTypeMixin";
//import ActionMenu from "@/components/Buttons/ActionMenu.vue";
import Avatar from "@/components/Buttons/Avatar.vue";
import UserTypeTextTemplate from "@/components/UserTypeTextTemplate.vue";
import PartnerCompanyListItem from "@/views/admin/partnercompany/PartnerCompanyListItem.vue";

export default {
    name: "PartnerUserListItem",
    props: {
        item: Object,
        isMe: Boolean,
    },
    components: {
        //ActionMenu,
        Avatar,
        UserTypeTextTemplate,
        PartnerCompanyListItem,
    },
    mixins: [
        UserTypeMixin,
    ],

    data() {
        return {
            thiscontext: this,
        };
    },

    mounted() { },

    methods: {
        emitClick() {
            this.$emit('click', this.item);
        },

        openPartnerCompany(id) {
            this.$router.push({ name: 'ViewPartnerCompanyInfo', params: { partnerCompanyId: id } });
        },

        async toggleUserActive() {
            this.item.loading = true;
            var response = await clientAPI.methods.changeUserActive(this.item.Id)
            this.item.loading = false;
            this.$emit('change', response)
        },

        async sendSetPasswordToDefaultMail() {
            this.item.loading = true;
            await clientAPI.methods.setPasswordToDefault(this.item.EmailAdress);
            this.item.loading = false;
        },
    },

    computed: {
        actionlist() {
            var list = [
                // { '#': 1, title: 'Open user in new tab', icon: "mdi-open-in-new", iconsize: 18, hovercolor: "primary", method: "openMachineInNewTab" },
                //{ '#': 2, title: 'Edit user', icon: "mdi-pencil", iconsize: 22, hovercolor: "tertiary", method: "emitClick" },
                //{ '#': 3, title: 'Send set password mail to user', icon: "mdi-email-alert", iconsize: 18, hovercolor: "warning", method: "transferMachineWork" },
                { '#': 4, title: 'Reset password to default', icon: "mdi-form-textbox-password", iconsize: 22, hovercolor: "error", method: "sendSetPasswordToDefaultMail" },
                //{ '#': 5, title: 'Deactivate user', icon: "mdi-account-off", iconsize: 18, hovercolor: "error", method: "remove" },
            ];
            /*
            if (!this.usedMachineIds || this.usedMachineIds.length < 2) {
                list = list.filter(x => x['#'] != 2)
            }^
            */
            return list;
        },
    },

    watch: {},
};
</script>

<style scoped>
.deactivated {
    background-color: var(--v-disabled-lighten1) !important;
}

.deactivated:not(:hover) .v-list-item__content {
    color: var(--v-disabled-darken2) !important;
    text-decoration: line-through !important;
}
</style>